import { __awaiter } from "tslib";
import AjaxUtils from './ajaxUtils';
const fetchAccountIntentTopics = () => __awaiter(void 0, void 0, void 0, function* () { return AjaxUtils.get('/api/intent/account-topics'); });
export { fetchAccountIntentTopics };
